// src/utils/DeltaSocketClient.js

// let SymbolsArr =  [     "SIGNUSD",  "AI16ZUSD",     "MUBARAKUSD",
//     "TRUMPUSD",
//     "FARTCOINUSD",
//     "COOKIEUSD",
//     "GRIFFAINUSD",
//     "IPUSD",
//     "POPCATUSD",
//     "GOATUSD",     "HYPEUSD",
//     "SPXUSD",     "MOODENGUSD",
//     "SOPHUSD",    "MEMEFIUSD",
//     "AIXBTUSD",     "ONDOUSD",
//     "API3USD",     "JTOUSD",
//     "MANAUSD",     "SANDUSD",
//     "IOTAUSD",     "PENDLEUSD",
//     "SAHARAUSD",     "LTCUSD",
//     "OPUSD",     "AUCTIONUSD",
//     "RUNEUSD",    "TAOUSD",
//     "MEUSD",     "CAKEUSD",
//     "PUMPUSD",     "KAITOUSD",
//     "BLURUSD",     "MELANIAUSD",
//     "UNIUSD",     "SEIUSD",
//     "DYDXUSD",     "LDOUSD",
//     "ETHFIUSD",     "ETCUSD",
//     "ETHUSD",     "OMNIUSD",
//     "RSRUSD",      "TRBUSD",
//     "SHIBUSD",     "TRXUSD",
//     "BCHUSD",     "ENAUSD",
//     "SUSD",     "MASKUSD",
//     "JUPUSD",     "SUSHIUSD",
//     "JASMYUSD",     "DOTUSD",
//     "HBARUSD",     "FLOKIUSD",
//     "KSMUSD",     "SOLUSD",
//     "MOVEUSD",     "BMTUSD",
//     "PENGUUSD",     "STXUSD",
//     "PEOPLEUSD",     "TIAUSD",
//     "BIOUSD",     "BNBUSD",
//     "SUNUSD",     "NEARUSD",
//     "MKRUSD",     "SUIUSD",
//     "SOLVUSD",     "GLMUSD",
//     "PNUTUSD",     "ALGOUSD",
//     "AVAXUSD",     "FILUSD",
//     "BTCUSD",     "INJUSD",
//     "AAVEUSD",     "ADAUSD",
//     "POLUSD",     "EIGENUSD",
//     "LISTAUSD",     "ARBUSD",
//     "BBUSD",      "INITUSD",
//     "DOGSUSD",     "PEPEUSD",
//     "ARUSD",     "BERAUSD",
//     "LINKUSD" ,     "BONKUSD",
//     "NOTUSD",     "MANTAUSD",
//     "IOUSD",
//     "OMUSD",
//     "APTUSD",
//     "DOGEUSD",
//     "ATOMUSD",
//     "MEMEUSD",
//     "TSTUSD",
//     "LAYERUSD",
//     "ORDIUSD",
//     "AINUSD",
//     "HUSD",
//     "MUSD",
//     "CROSSUSD",
//     "BIDUSD",
//     "WCTUSD",
//     "DEEPUSD",
//     "RAREUSD",
//     "REDUSD",
//     "PIUSD",
//     "BAKEUSD",
//     "VVVUSD",
//     "VINEUSD",
//     "ARCUSD",
//     "AVAAIUSD",
//     "VANAUSD",
//     "SWARMSUSD",
//     "HIVEUSD",
//     "SONICUSD",
//     "USUALUSD",
//     "VIRTUALUSD",
//     "1MBABYDOGEUSD",
//     "XLMUSD",
//     "ACTUSD",
//     "SAGAUSD",
//     "NEIROUSD",
//     "GALAUSD",
//     "ZKUSD",
//     "ZROUSD",
//     "XAIUSD",
//     "ALTUSD",
//     "WLDUSD",
//     "WIFUSD",
//     "XRPUSD",
//     "2BTCUSDT",
//     "6BTCUSDT",
//   ]

const SymbolsArr = [
  "BTCUSD", "ETHUSD", "SOLUSD", "BNBUSD", "XRPUSD",
  "DOGEUSD", "ADAUSD", "AVAXUSD", "LINKUSD", "SHIBUSD"
];


class DeltaSocketClient {
  constructor(
    symbols = SymbolsArr,
    onMessageCallback
  ) {
    if (DeltaSocketClient.instance) {
      return DeltaSocketClient.instance;
    }

    this.url = "wss://socket.india.delta.exchange";
    this.socket = null;
    this.symbols = SymbolsArr;
    this.onMessageCallback = onMessageCallback;
    this.subscribedSymbols = new Set(SymbolsArr);
    this.priceCache = {};
    this.reconnectTimer = null;
    this.healthCheckInterval = null;

    DeltaSocketClient.instance = this;

    // START AUTO HEALTH CHECK EVERY 5 MIN
    this.startHealthCheck();
  }

  // 🔥 MAIN CONNECT FUNCTION
  connect1() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) return;

    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      this._sendSubscribe([...this.subscribedSymbols]);
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data?.type === "v2/ticker") {
        if (data.symbol && data.spot_price) {
          this.priceCache[data.symbol] = data.spot_price;
        }
      }

      if (this.onMessageCallback) {
        this.onMessageCallback(data);
      }
    };

    this.socket.onerror = () => {
      console.warn("❌ WebSocket error detected");
    };

    this.socket.onclose = () => {
      console.warn("⚠️ WebSocket closed. Reconnecting in 3 seconds...");
      this.socket = null;

      if (!this.reconnectTimer) {
        this.reconnectTimer = setTimeout(() => {
          this.reconnectTimer = null;
          this.connect1();
        }, 3000);
      }
    };
  }

  // SEND SUBSCRIBE
  _sendSubscribe(SymbolsArr) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return;

    const payload = {
      type: "subscribe",
      payload: { channels: [{ name: "v2/ticker", symbols: SymbolsArr }] },
    };

    this.socket.send(JSON.stringify(payload));
  }

  // ADD NEW SYMBOL
  subscribe(symbol) {
    if (this.subscribedSymbols.has(symbol)) return;

    this.subscribedSymbols.add(symbol);

    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this._sendSubscribe([symbol]);
    }
  }

  // ⭐ GET PRICE (AUTO FIX IF PRICE NOT COMING)
  getPrice(symbol) {
    // 1) SOCKET DOWN → RECONNECT
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      console.warn("🔄 Socket not active. Reconnecting...");
      this.connect1();
    }

    // 2) PRICE NOT AVAILABLE → RECONNECT + RESUBSCRIBE
    if (!this.priceCache[symbol]) {
      console.warn(`⚠️ No price for ${symbol}. Reconnecting + resubscribing...`);
      this.connect1();
      this.subscribe(symbol);
      return null;
    }

    return this.priceCache[symbol];
  }

  // DISCONNECT
  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    if (this.healthCheckInterval) {
      clearInterval(this.healthCheckInterval);
      this.healthCheckInterval = null;
    }
  }

  // ⭐ AUTO HEALTH-CHECK EVERY 5 MINUTES
  startHealthCheck() {
    if (this.healthCheckInterval) return;

    this.healthCheckInterval = setInterval(() => {

      const socketDead =
        !this.socket ||
        this.socket.readyState === WebSocket.CLOSED ||
        this.socket.readyState === WebSocket.CLOSING;

      const noPricesComing =
        Object.keys(this.priceCache).length === 0;

      if (socketDead) {
        console.warn("❌ Socket dead. Reconnecting...");
        this.connect1();
        return;
      }

      if (noPricesComing) {
        console.warn("⚠️ No new prices detected. Reconnecting...");
        this.connect1();
        return;
      }

    }, 5 * 60 * 1000); // every 5 minutes
  }
}

export default DeltaSocketClient;

